/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  console.log('custom.js loaded');

  // Fire standard Meta AddToCart event
  function trackAddToCart() {
    console.log('trackAddToCart called');
    if (typeof fbq === 'function') {
      fbq('track', 'AddToCart');
      console.log('Meta AddToCart fired');
    } else {
      console.log('fbq not available yet');
    }
  }

  // Intercept fetch calls to /cart/add
  if (window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0];

      if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
        trackAddToCart();
      } else if (url && typeof url.url === 'string' && url.url.indexOf('/cart/add') !== -1) {
        // in case fetch is called with a Request object
        trackAddToCart();
      }

      return originalFetch.apply(this, arguments);
    };
  }

  // Intercept XMLHttpRequest calls to /cart/add (fallback)
  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__isAddToCart = (
      method &&
      method.toUpperCase() === 'POST' &&
      typeof url === 'string' &&
      url.indexOf('/cart/add') !== -1
    );
    return originalOpen.apply(this, arguments);
  };

  var originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function (body) {
    if (this.__isAddToCart) {
      trackAddToCart();
    }
    return originalSend.apply(this, arguments);
  };

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
